import { ImagePicture } from 'approot/shared/images/images';

import contentMailAvif from './content-mailbox.avif';
import contentMailWebp from './content-mailbox.webp';
import contentMailPng from './content-mailbox.png';

const ImageContentMailbox = ({
  width,
  height,
}: {
  width?: number;
  height?: number;
}) => (
  <ImagePicture
    lazyLoad
    style={{ width: width || 120, height: height || 120 }}
    avif={{ path: contentMailAvif }}
    webp={{ path: contentMailWebp }}
    png={{ path: contentMailPng }}
  />
);

export default ImageContentMailbox;
